import module from './store'
import { extendStore } from '@vue-storefront/core/helpers'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const CartExtended: StorefrontModule = function ({ router, store }) {
  extendStore('cart', module)
}
